import { render, staticRenderFns } from "./storemanagement.vue?vue&type=template&id=596bab04&"
import script from "./storemanagement.vue?vue&type=script&lang=js&"
export * from "./storemanagement.vue?vue&type=script&lang=js&"
import style0 from "./storemanagement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports